import { handleSlotRenderEnded } from "./slot_render_ended"
import { pushViewableImpressionToDataLayer } from "./viewable_impression"
import {
  trackSlotRequested,
  trackSlotOnLoad,
} from "../ad_performance_tracking/ad_perfomance_tracking"

export const registerListenersForAdLifecycleEvents = () => {
  window.googletag.cmd.push(() => {
    window.googletag.pubads().addEventListener('slotRenderEnded', handleSlotRenderEnded)
    window.googletag.pubads().addEventListener('slotRequested', trackSlotRequested)
    window.googletag.pubads().addEventListener('slotOnload', trackSlotOnLoad)
    window.googletag.pubads().addEventListener('impressionViewable', pushViewableImpressionToDataLayer)
  })
}
